import { render, staticRenderFns } from "./SensorialForm.vue?vue&type=template&id=d9f6f4f6"
import script from "./SensorialForm.vue?vue&type=script&lang=js"
export * from "./SensorialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports